import { useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import printJS from "print-js";
import { Info, Printer } from "lucide-react";

import { formatMiles, formatMilesDecimal } from "@/services/Utils";
import { base64toBlob } from "@/hooks/printer/useBase64";
import { usePrintCodes } from "@/hooks/inventories/useInventories";

import Fetching from "@/components/Fetching/Fetching";

import classes from "../../purchase.module.scss";

const OrdersSaleCodes = ({ product }) => {
	const { mutate: print, isLoading: loadPrint } = usePrintCodes();

	const [showCodes, setShowCodes] = useState(false);

	const handleClose = () => {
		setShowCodes(false);
	};

	const handlePrint = () => {
		const allIds = product.inventories.flatMap((inventory) => inventory.ids.split(",").map((id) => Number(id.trim())));

		print(allIds, {
			onSuccess: (response) => {
				const blobUrl = URL.createObjectURL(base64toBlob(`data:application/pdf;base64,${response.url}`));

				printJS(blobUrl);
			},
		});
	};

	if (loadPrint) {
		return <Fetching topMargin={"5px"} bottomMargin={"5px"} />;
	}

	return (
		<>
			<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Info color="#0d6efd" size={25} style={{ cursor: "pointer" }} onClick={() => setShowCodes(true)} />
				<Printer color="#28a745" size={25} style={{ cursor: "pointer" }} onClick={handlePrint} />
			</div>

			<Modal show={showCodes} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
				<Modal.Header closeButton style={{ padding: "8px 15px" }}>
					<Modal.Title style={{ fontSize: "15px" }}>Códigos Inventario</Modal.Title>
				</Modal.Header>

				<Modal.Body className={classes.modalCodes}>
					<Table>
						<thead>
							<tr>
								<th className={classes.tableTh}>Producto</th>
								<th className={classes.tableTh}>Código</th>
								<th className={classes.tableTh}>Cantidad</th>
								<th className={classes.tableTh}>Contenido</th>
								<th className={classes.tableTh}>U.M</th>
							</tr>
						</thead>

						<tbody>
							{product.inventories &&
								product.inventories.map((item, i) => {
									return (
										<tr key={i}>
											<td className={classes.tableTd}>{item.product_name}</td>
											<td className={classes.tableTd}>
												<strong>
													{item.code
														? item.code
														: item.code_generic
															? `Genérico (${item.code_generic}) ${item.product_generic}`
															: `Etiquetas pendientes de impresión`}
												</strong>
											</td>
											<td className={classes.tableTd}>{formatMiles(product.quantity)}</td>
											<td className={classes.tableTd}>{formatMilesDecimal(item.container_content)}</td>
											<td className={classes.tableTd}>{item.unit_measurement}</td>
										</tr>
									);
								})}
						</tbody>
					</Table>
				</Modal.Body>

				<Modal.Footer style={{ padding: "5px" }}>
					<Button style={{ fontSize: "0.8em" }} variant="success" onClick={() => handleClose()}>
						Aceptar
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default OrdersSaleCodes;
